import {mixpanel, mixpanelService}from './MixpanelService'
import { MixpanelAnalyticsEventWeb } from './AnalyticsEvents'
import { AnalyticsManagerInterface } from '@meprism/shared/src/services/AnalyticsManager'

mixpanelService.init()

const AnalyticsManager: AnalyticsManagerInterface = {
  trackWithProperties: async (event: any, properties: any) =>
    mixpanel?.track?.(event, properties),
    error: async (
    event: string | Error | Record<string, any>,
    properties?: unknown,
  ) => {
    let err: Error | Record<string, any>
    if (typeof event === 'string' || event instanceof String) {
      err = new Error(event as string)
    } else {
      err = event as Error | Record<string, any>
    }

    let props: Record<string, any> = {}
    if (properties instanceof Error) {
      props = {
        messageDetail: properties?.message,
        nameDetail: properties?.name,
      }
    } else if (typeof properties === 'string' || event instanceof String) {
      props = {
        messageDetail: properties,
      }
    } else if (typeof properties === 'object' && properties !== null) {
      props = properties
    }

    mixpanel?.track?.(`ERROR: ${err?.name}`, {
      message: err?.message,
      name: err?.name,
      ...props,
    })
  },
  identify: async (id: string) => mixpanel?.identify?.(id),
  set: async (properties: any) => mixpanel.people.set(properties),
  setOnce: async (properties: any) => mixpanel.people.set_once(properties),
  union: async (name: string, value: any) =>
    mixpanel.people?.union(name, value),
  timeEvent: async (event: any) => mixpanel?.time_event?.(event),
  trackTypedEvent: async (typedEvent: MixpanelAnalyticsEventWeb) => {
    const { event, ...rest } = typedEvent
    return mixpanel?.track?.(event, rest)
  },
  reset: async () => mixpanel?.reset?.(),
  registerSuperPropertiesOnce: async (properties: Record<string, any>) =>
    mixpanel?.register_once(properties),
  registerSuperProperties: async (properties: Record<string, any>) =>
    mixpanel.register(properties),
  getSuperProperty: async (property: string): Promise<any> =>
    mixpanel.get_property(property),
  alias: async (muid: string) => {
    mixpanel.alias(muid);
  },
  getDistinctId: () => {
    return mixpanel?.get_distinct_id?.();
  },
  unregister : async(property: string) => mixpanel?.unregister(property)
}

export default AnalyticsManager
